<button
  [class]="classes"
  [disabled]="isLoading || disabled"
  (click)="handleClick()"
  [type]="type"
>
  <span *ngIf="isLoading" class="w-full flex justify-center items-center gap-3">
    <svg
      class="size-6 animate-spin"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      />
      <path
        class="opacity-75"
        fill="none"
        stroke="currentColor"
        stroke-width="4"
        stroke-linecap="round"
        d="M12 2a10 10 0 0 1 0 20"
      />
    </svg>
    {{ loadingLabel }}
  </span>
  <span *ngIf="!isLoading">{{ label }}</span>
</button>
